<input
    #inputRef
    [id]="id"
    [formControl]="inputFormControl"
    [nbAutocomplete]="autoControl"
    fullWidth
    nbInput
    type="text"
    placeholder="{{ placeholder ? placeholder : '' }}"
    (blur)="autocompleteReady && onBlur.emit(true)"
    (keyup)="isValueSelected = false"
    [ngxScrollLock]="autocompleteDirective?.isOpen || false"
/>
<nb-autocomplete #autoControl (selectedChange)="onSelectedChange($event)" [handleDisplayFn]="viewHandle">
    <!--Using $event.stopPropagation() onClick prevents nb-autocomplete's parent component (with ngxClickOutside) from closing when an option is clicked.
     Doesn't affect default behavior of nb-autocomplete. -->
    <nb-option
        (click)="$event.stopPropagation()"
        *ngFor="let option of options$ | async"
        [value]="option"
        class="custom-default-option"
    >
        <ng-template *ngTemplateOutlet="customTemplate || defaultTemp; context: {$implicit: option}"></ng-template>
    </nb-option>
    <nb-option
        [disabled]="infoOptionDisabled"
        (click)="$event.stopPropagation(); closeAutocomplete()"
        *ngIf="(options$ | async) && shouldDisplayOptionalLabel(inputFormControl.value)"
    >
        {{ getNoOptionsLabel(inputFormControl.value) }}
    </nb-option>
</nb-autocomplete>

<ng-template #defaultTemp let-option>
    <div class="option">
        <b class="mb-1">{{ option.name }}</b>
        <div class="info ellipsis">{{ option.description }}</div>
    </div>
</ng-template>
